import * as React from 'react';
import { Link, NavLink } from 'react-router-dom';
import { LoginPart } from '../components/auth/LoginPart';
import { QuotesInformer } from '../components/informers/QuotesInformer';
import * as Session from '../service/Session';
import * as API from '../service/apisvc';
import * as DTO from '../service/DTOs';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faLink, faUnlink, faExclamationTriangle } from '@fortawesome/free-solid-svg-icons'
import { faCommentAlt } from '@fortawesome/free-regular-svg-icons'



const iconLink = <FontAwesomeIcon icon={faLink} size="lg" />
const iconUnLink = <FontAwesomeIcon icon={faUnlink} size="lg" />
const iconError = <FontAwesomeIcon icon={faExclamationTriangle} size="1x" />


type NavMenuProps = NavMenuState & { xsrfToken?: string } & { connection: DTO.HubConnection };

const initialstate: NavMenuState = {
    user: { identityState: Session.AnonimousIdentityState },
    syshdr: { hasfreshchanges: false, sstamp: '' },
    tmessages: [],
    appId: 0,
    appFamily: 'Trading',
    sharedChatId: 0,
    chatactivity: []
}

interface NavMenuState {
    user: Session.UserState;
    syshdr: DTO.SystemHeader;
    tmessages: DTO.AgentTextMessage[];
    appId: number;
    appFamily: string;
    sharedChatId?: number;
    chatactivity: DTO.AgentChatActivity[];
    marketquotes?: DTO.MarketQuotes;
}


export class NavMenu extends React.Component<NavMenuProps, NavMenuState> {
    constructor(props: NavMenuProps) {
        super(props);
        this.state = {
            ...initialstate, ...{ user: props.user }, ...{ syshdr: props.syshdr }
        }

        //console.log('NavMenu state');
        //console.log(this.state);
    }

    //componentDidMount() {
    //    let _user = API.currentUser();
    //    if (_user)
    //        this.setState({ ...this.state, ...{ user: _user } });

    //    console.log('User in store');
    //    console.log(_user);
    //    console.log('state');
    //    console.log(this.state);
    //}

    componentWillReceiveProps(nextProps: NavMenuProps) {
        this.setState({ user: nextProps.user });
        this.setState({ syshdr: nextProps.syshdr });
        this.setState({ tmessages: nextProps.tmessages });
        this.setState({ appId: nextProps.appId });
        this.setState({ sharedChatId: nextProps.sharedChatId });
        this.setState({ chatactivity: nextProps.chatactivity });
    }

    public render() {
        let tradeSession = this.state.user.identityState.isRepoTrader;

        //disabled={!this.state.user.identityState.isTrader}
        let settingsMenu = tradeSession
            ? <li>
                <NavLink to={'/settings'} activeClassName='active' className='linkbtn'>
                    <span className='glyphicon glyphicon-th-list'></span> Настройки
                </NavLink>
            </li>
            : '';

        let helpMenu = false ?
            <li>
                <NavLink to={'/help'} activeClassName='active' className='linkbtn'>
                    <span className='glyphicon glyphicon-education'></span> Справка
                            </NavLink>
            </li>
            : undefined;

        let tradeMenu = tradeSession
            ? <li>
                <NavLink to={'/app'} activeClassName='active' className='linkbtn'>
                    <span className='glyphicon glyphicon-th-list'></span> Торговать{/*Вход на тестовый сервер*/}
                </NavLink>
            </li>
            : undefined;

        let statusMenu = tradeSession
            ? <div className="navbar-brand" style={{ fontSize: '14px' }}>
                {
                    this.props.connection.status == 'connected' ? <div className="otc-header-ok">{iconLink}<span> Подключение: OK</span></div>
                        : (this.props.connection.status == 'reconnecting' ? <div className="otc-header-warn">{iconUnLink}<span> Подключение .... </span></div>
                            : <div className="otc-header-error">{iconError}<span> Нет подключения!</span></div>
                        )
                }
            </div>
            : undefined;

        let mainMenu = !tradeSession
            ? <li>
                <NavLink to={'/'} exact activeClassName='active' className='linkbtn'>
                    <span className='glyphicon glyphicon-home'></span> Главная
                </NavLink>
            </li>
            : undefined;

        let quotes = this.props.marketquotes ?
            <QuotesInformer marketquotes={this.props.marketquotes} />
            : undefined;
        //{ settingsMenu }

        //<li>
        //    <NavLink to={'/fetchdata'} activeClassName='active'>
        //        <span className='glyphicon glyphicon-th-list'></span> Fetch data
        //                    </NavLink>
        //</li>
        return <div className='main-nav'>
            <div className='navbar navbar-inverse'>
                <div className='navbar-header'>
                    <button type='button' className='navbar-toggle' data-toggle='collapse' data-target='.navbar-collapse'>
                        <span className='sr-only'>Toggle navigation</span>
                        <span className='icon-bar'></span>
                        <span className='icon-bar'></span>
                        <span className='icon-bar'></span>
                    </button>
                    <Link className='navbar-brand' to={tradeSession ? '/app' : '/'}>OTC {this.props.appFamily}</Link>
                </div>
                <div className='navbar-collapse collapse'>
                    <ul className='nav navbar-nav'>
                        {mainMenu}
                        {helpMenu}
                        {tradeMenu}
                    </ul>

                    {statusMenu}

                    {quotes}

                    <LoginPart {...this.state} />

                </div>
            </div>
        </div>;
    }
}












//import * as React from 'react';
//import { Link, NavLink } from 'react-router-dom';
//import { LoginPart } from '../components/auth/LoginPart';
//import * as Session from '../service/Session';
//import * as API from '../service/apisvc';
//import * as DTO from '../service/DTOs';



//type NavMenuProps = NavMenuState & { xsrfToken?: string };

//const initialstate: NavMenuState = {
//    user: { identityState: Session.AnonimousIdentityState },
//    syshdr: { hasfreshchanges: false, sstamp: '' },
//    tmessages: []
//}

//interface NavMenuState {
//    user: Session.UserState;
//    syshdr: DTO.SystemHeader;
//    tmessages: DTO.AgentTextMessage[];
//}


//export class NavMenu extends React.Component<NavMenuProps, NavMenuState> {
//    constructor(props: NavMenuProps) {
//        super(props);
//        this.state = {
//            ...initialstate, ...{ user: props.user }, ...{ syshdr: props.syshdr }
//        }

//        //console.log('NavMenu state');
//        //console.log(this.state);
//    }

//    //componentDidMount() {
//    //    let _user = API.currentUser();
//    //    if (_user)
//    //        this.setState({ ...this.state, ...{ user: _user } });

//    //    console.log('User in store');
//    //    console.log(_user);
//    //    console.log('state');
//    //    console.log(this.state);
//    //}

//    componentWillReceiveProps(nextProps: NavMenuProps) {
//        this.setState({ user: nextProps.user });        
//        this.setState({ syshdr: nextProps.syshdr });
//        this.setState({ tmessages: nextProps.tmessages });
//    }

//    public render() {
//        let tradeSession = this.state.user.identityState.isRepoTrader;

//        //disabled={!this.state.user.identityState.isTrader}
//        let settingsMenu = tradeSession
//            ? <li>
//                <NavLink to={'/settings'} activeClassName='active'   >
//                    <span className='glyphicon glyphicon-th-list'></span> Настройки
//                </NavLink>
//            </li>
//            : '';

//        let tradeMenu = tradeSession
//            ? <li>
//                <NavLink to={'/app'} activeClassName='active'   >
//                    <span className='glyphicon glyphicon-th-list'></span> Торговать
//                </NavLink>
//            </li>
//            : '';

//        let mainMenu = !tradeSession
//            ? <li>
//                <NavLink to={'/'} exact activeClassName='active'>
//                    <span className='glyphicon glyphicon-home'></span> Главная
//                </NavLink>
//            </li>
//            : undefined;

//        //{ settingsMenu }

//        //<li>
//        //    <NavLink to={'/fetchdata'} activeClassName='active'>
//        //        <span className='glyphicon glyphicon-th-list'></span> Fetch data
//        //                    </NavLink>
//        //</li>
//        return <div className='main-nav'>
//                <div className='navbar navbar-inverse'>
//                <div className='navbar-header'>
//                    <button type='button' className='navbar-toggle' data-toggle='collapse' data-target='.navbar-collapse'>
//                        <span className='sr-only'>Toggle navigation</span>
//                        <span className='icon-bar'></span>
//                        <span className='icon-bar'></span>
//                        <span className='icon-bar'></span>
//                    </button>
//                    <Link className='navbar-brand' to={tradeSession ? '/app': '/' }>OTC Repo</Link>
//                </div>
//                <div className='navbar-collapse collapse'>
//                    <ul className='nav navbar-nav'>
//                        {mainMenu}
//                        <li>
//                            <NavLink to={ '/help' } activeClassName='active'>
//                                <span className='glyphicon glyphicon-education'></span> Справка
//                            </NavLink>
//                        </li>
                        
//                        {tradeMenu}
//                    </ul>

//                    <LoginPart user={this.state.user} syshdr={this.state.syshdr} tmessages={this.state.tmessages} />

//                </div>
//            </div>
//        </div>;
//    }
//}
